import { render, staticRenderFns } from "./FoldersAllTable.vue?vue&type=template&id=16cb2586&scoped=true"
import script from "./FoldersAllTable.vue?vue&type=script&lang=js"
export * from "./FoldersAllTable.vue?vue&type=script&lang=js"
import style0 from "./FoldersAllTable.vue?vue&type=style&index=0&id=16cb2586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb2586",
  null
  
)

export default component.exports